import fetch from "cross-fetch"

const getQuery = (params = {}) => new URLSearchParams(params).toString();
const getUrl = (endpoint, params = {}) => `${endpoint}?${getQuery(params)}`;

const params = {
  headers: new Headers({
    'Content-Type': 'application/json',
    'X-Accept': 'application/json; charset=UTF8',
  }),
};

export default {
  getCount(url) {
    return fetch(getUrl('/api/saves', {url}), params)
      .then(response => response.json())
  }
}
